<template>
  <tr v-if="item.type === 0 ">
    <td class="group_res" >
      {{ name }}({{ item.online }} / {{ item.count }})
    </td>
  </tr>
  <tr v-else-if="item.type === -1">
    <td class="group_res">
      {{ translate('no_result') }}
    </td>
  </tr>
  <router-link v-else :to="go_to()" class="link">
    <tr>
      <td :data-label="translate('esim_profile.mno')">
        {{ item.mno }}
      </td>

      <td :data-label="translate('esim_profile.blocked')" style="width: 120px">
      <span v-if="+item.blocked !== 0" class="badge" :class="simcard_blocked_color(+item.blocked)">
        {{simcard_blocked_text(+item.blocked)}}
      </span>
      </td>

      <td :data-label="translate('esim_profile.device_fid')">
        {{ item.device_fid }}
      </td>

      <td :data-label="translate('esim_profile.device_name')">
        {{ item.device_name }}
      </td>

      <td :data-label="translate('esim_profile.number')">
        {{ item.msisdn }}
      </td>

      <td :data-label="translate('esim_profile.imsi')">
        {{ item.imsi }}
      </td>

      <td :data-label="translate('esim_profile.iccid')">
        {{ item.iccid }}
      </td>

      <td :data-label="translate('esim_profile.status')" style="width: 120px">
      <span class="badge" :class="simcard_status_color(+item.active)">
        {{simcard_status_text(+item.active)}}
      </span>
      </td>

      <td :data-label="translate('esim_profile.ts_update')">
        {{ get_date(item.ts_update) }}
      </td>

    </tr>
  </router-link>
</template>
<script>

export default {
  name: 'EsimProfileListItem',
  components: {
  },
  props: ['item', 'index', 'checked', 'checkbox', 'groups', 'traffic_list'],
  data () {
    return {
      status: false,
      chartStatus: false,
      resize: false
    }
  },
  computed: {
    name () {
      if (this.item.type === 0) {
        return this.$store.getters.getEsimProfileGroupById(this.item.id).name
      }
      else {
        let name = this.item.name2
        if (this.$store.getters.getPermissions.permissionGod) {
          name += ' / '
          name += this.item.name
        }
        return name
      }
    },
  },
  activated () {
    this.$emit('mount', this.index)
  },
  mounted () {
    this.$emit('mount', this.index)
  },
  methods: {
    simcard_esim(type){
      switch (type) {
        case 0: return 'sim'
        case 1: return 'esim'
      }
    },
    simcard_tariff(id){
      return this.traffic_list[id] ? this.traffic_list[id].tariff_name : ''
    },
    simcard_status_text(status){
      switch (status) {
        case 0: return this.translate('esim_profile.status_info.not_active')
        case 1: return this.translate('esim_profile.status_info.active')
      }
    },
    simcard_status_color(status){
      switch (status) {
        case 0: return 'gray'
        case 1: return 'green'
      }
    },
    simcard_blocked_text(status){
      switch (status) {
        case 0: return this.translate('esim_profile.status_info.unblocked')
        case 1: return this.translate('esim_profile.status_info.blocked')
      }
    },
    simcard_blocked_color(status){
      switch (status) {
        case 0: return 'gray'
        case 1: return 'orange'
      }
    },
    check () {
      this.$emit('check', !this.item.checked, this.item.device_id)
    },
    cntx_menu (e) {
      this.$emit('contextmenu', e, this.item)
    },
    go_to () {
      return {path: '/esim_profile/' + this.item.id}
    },
    ready () {
      this.$emit('ready', this.index)
    }
  }
}
</script>

<style lang="scss" scoped>
  .error_device {
    font-size: 20px;
    color: red;
  }
  .group_res{
    cursor: auto;
  }
</style>
